export const COM_705_TEST_NAME = 'client_proprofile_goals_service_tiles_com_705_20220124';
export const COM_705_TEST_PERCENT = 0.5;
export const COM_1253_TEST_NAME = 'client_proprofile_service_tabs_to_pro_profile_com_1253_20230719';
export const COM_1253_TEST_PERCENT = 0.5;

export const ROTATING_HEADER_TEXTS = [
  'Healthier',
  'Stronger',
  'Longer',
];

export const HAIR_RELATED_SERVICE_CATEGORIES = [
  'Barber',
  'Braids',
  'Chemical Perms',
  'Curling Treatments',
  'Hair Color',
  'Hair Treatments',
  'Highlight',
  'Kids',
  'Knots',
  'Locs',
  'Men\'s Color',
  'Men\'s Haircut',
  'Natural Hair',
  'Relaxers',
  'Sets & Styles',
  'Special Occasion Style',
  'Straightening Treatments',
  'Style',
  'Twists',
  'Weaves',
  'Wigs',
  'Women\'s Haircut',
];
